import { Graph } from '@square/ignition';
import {
  ApiExplorerOasContainer,
  ApiExplorerRequestRunnerContainer,
} from '@squareup/dex-feature-dex-tech-main-api-explorer-container';
import {
  ApiExplorerRequestContentContainer,
  ApiExplorerResponseContentContainer,
  ApiExplorerSelectorContainer,
  ApiExplorerHomeContainer,
} from '@squareup/dex-feature-shared-api-explorer';
import { useSelectSpecVersionMetadata } from '@squareup/dex-store-access-dex-tech-main-spec-version-hooks';
import { ReferenceObjectModalProvider } from '@squareup/dex-tech-reference-properties';
import {
  ApiExplorerContentLayout,
  ApiExplorerRequestResponseAsideLayout,
} from '@squareup/dex-ui-shared-api-explorer-page-layout';
import React, { FC } from 'react';

interface Props {
  graph: Graph;
}

const ExplorerIndexPage: FC<Props> = ({ graph }) => {
  const { isVersionSelectionLatest } = useSelectSpecVersionMetadata();

  return (
    <>
      <ReferenceObjectModalProvider>
        <ApiExplorerOasContainer
          graph={graph}
          endpoint={undefined}
          api={undefined}
        >
          <ApiExplorerRequestRunnerContainer>
            <ApiExplorerContentLayout
              apiSelectors={<ApiExplorerSelectorContainer />}
              fieldContent={
                <ApiExplorerHomeContainer
                  isVersionSelectionLatest={isVersionSelectionLatest}
                />
              }
              requestResponseContent={
                <ApiExplorerRequestResponseAsideLayout
                  requestContent={<ApiExplorerRequestContentContainer />}
                  responseContent={<ApiExplorerResponseContentContainer />}
                />
              }
            />
          </ApiExplorerRequestRunnerContainer>
        </ApiExplorerOasContainer>
      </ReferenceObjectModalProvider>
    </>
  );
};

export { ExplorerIndexPage };
